import type Highcharts from 'highcharts/highstock';
import type { RmData } from '../graphql/types';
import { displayDate } from '../helpers/date-helpers';
import { masterColumns } from '../renderers/master-columns';

const defaultMetrics = ['sold', 'remaining', 'ooo'];

const colors = {
  sold: 'rgba(33, 224, 29, 0.5)',
  remaining: 'rgb(41, 168, 221)',
  ooo: 'rgb(255, 191, 66)',
};

export function tonightDonut(data: RmData, metrics = defaultMetrics): Highcharts.Options {
  const options = {
    chart: {
      margin: [0, 0, 0, 0],
      plotShadow: false,
      spacing: [0, 0, 0, 0],
      type: 'pie',
    } as Highcharts.ChartOptions,
    exporting: {
      enabled: false,
    } as Highcharts.ExportingOptions,
    title: {
      floating: true,
      text: `${data.sold}<br>Sold`,
      verticalAlign: 'middle',
    } as Highcharts.TitleOptions,
    plotOptions: {
      pie: {
        alignTo: 'plotEdges',
        allowPointSelect: false,
        cursor: 'pointer',
        dataLabels: {
          crop: false,
          distance: 10,
          enabled: true,
          format: '<b>{point.header}</b>: {point.percentage:.1f}%',
          style: {
            fontSize: '10px',
          },
        },
        size: '95%',
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y} Rooms</b>',
        },
      },
    } as Highcharts.PlotOptions,
    series: [
      {
        name: displayDate(data.stay_date),
        colorByPoint: true,
        innerSize: '40%',
        data: createSeriesData(),
        type: 'pie',
      } as Highcharts.SeriesPieOptions,
    ],
  };

  function createSeriesData(): Highcharts.PointOptionsObject[] {
    return metrics.map((metric) => {
      let yValue = data[metric as keyof RmData];

      if (yValue === null || yValue === undefined) {
        yValue = 0;
      }

      return {
        name: masterColumns[metric].tooltip,
        header: masterColumns[metric].header,
        color: colors[metric as keyof typeof colors],
        y: yValue,
      };
    });
  }

  return options;
}
